import React from "react";
import { ReactComponent as LoaderIcon } from "../SVGcomponents/LoaderAnim.svg";
import styles from "./styles.module.scss";

const Spinner: React.FC = () => {
  return (
    <div className={styles.loaderMainContainer}>
      <div className={styles.loaderContainer}>
        <LoaderIcon className={styles.loader} />
      </div>
    </div>
  );
};

export default Spinner;
